/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiQzovVXNlcnMvb3Jpb24vUHJvamVjdHMvc2ltcGxpY2l0eUVuZ2luZS92YWxtdXN0L3ZhbG11c3RmZS9zcmMvYXBwL2FnYXRleHRzY3JlZW5zL3BhZ2Utbm90LWZvdW5kL3BhZ2Utbm90LWZvdW5kLmNvbXBvbmVudC5zY3NzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL0M6L1VzZXJzL29yaW9uL1Byb2plY3RzL3NpbXBsaWNpdHlFbmdpbmUvdmFsbXVzdC92YWxtdXN0ZmUvc3JjL2FwcC9hZ2F0ZXh0c2NyZWVucy9wYWdlLW5vdC1mb3VuZC9wYWdlLW5vdC1mb3VuZC5jb21wb25lbnQuc2NzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/$$_gendir/app/agatextscreens/page-not-found/page-not-found.component.scss.shim.ngstyle.ts